<template>
    <div class="d-flex mt-3">
        <p class="me-1 fw-semibold">
            {{ defaultTenantLanguage.text }}
        </p>
        <Link
            v-if="tenantLanguages.length > 1"
            :href="route"
        >
            {{ __('settings.translation.label') }}
        </Link>
    </div>
</template>

<script setup>
defineProps({
    route: {
        type: String,
        default: null
    },
    tenantLanguages: {
        type: Array,
        default: () => { return [] }
    },
    defaultTenantLanguage: {
        type: Object,
        default: () => { return {} }
    }
})

</script>

<style scoped lang="scss">

</style>
